import { render, staticRenderFns } from "./ProductCollectionHorizontal.vue?vue&type=template&id=5bb9eb89&scoped=true&"
import script from "./ProductCollectionHorizontal.vue?vue&type=script&lang=js&"
export * from "./ProductCollectionHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollectionHorizontal.vue?vue&type=style&index=0&id=5bb9eb89&lang=scss&scoped=true&"
import style1 from "./ProductCollectionHorizontal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9eb89",
  null
  
)

component.options.__file = "ProductCollectionHorizontal.vue"
export default component.exports